<div class="flex flex-col h-full w-full bg-inner-layout-background overflow-hidden relative min-h-0 min-w-0">
  <header
    class="flex items-center justify-between py-3 px-4 bg-component-header border-b border-primary-border shrink-0 h-14">
    <div class="flex items-center gap-4 flex-1 min-w-0">
      <h1 class="text-lg font-bold text-heading flex items-center gap-2 m-0 truncate shrink-0">
        <i class="fa-solid fa-bug text-primary"></i>
        Public Bug Report
      </h1>

      <div
        class="flex items-center bg-alt-background border border-secondary-border rounded-lg p-1 gap-1 ml-4 shrink-0 shadow-sm">
        <button (click)="setViewMode('desktop')" nz-tooltip nzTooltipTitle="Desktop View"
          class="w-8 h-8 rounded-md flex items-center justify-center transition-colors focus:outline-none" [ngClass]="
            viewMode() === 'desktop'
              ? 'bg-component-inner text-primary shadow-sm'
              : 'text-secondary-text hover:text-primary'
          ">
          <i class="fas fa-desktop text-sm"></i>
        </button>
        <button (click)="setViewMode('tablet')" nz-tooltip nzTooltipTitle="Tablet View"
          class="w-8 h-8 rounded-md flex items-center justify-center transition-colors focus:outline-none" [ngClass]="
            viewMode() === 'tablet'
              ? 'bg-component-inner text-primary shadow-sm'
              : 'text-secondary-text hover:text-primary'
          ">
          <i class="fas fa-tablet-alt text-sm"></i>
        </button>
        <button (click)="setViewMode('mobile')" nz-tooltip nzTooltipTitle="Mobile View"
          class="w-8 h-8 rounded-md flex items-center justify-center transition-colors focus:outline-none" [ngClass]="
            viewMode() === 'mobile'
              ? 'bg-component-inner text-primary shadow-sm'
              : 'text-secondary-text hover:text-primary'
          ">
          <i class="fas fa-mobile-alt text-sm"></i>
        </button>
      </div>
    </div>

    <div class="flex items-center gap-3 justify-end shrink-0">
      <button nz-button [nzType]="isAddCommentMode() ? 'default' : 'primary'" (click)="toggleAddCommentMode()"
        class="font-bold shadow-sm flex items-center gap-2 transition-colors border-none h-8" [ngClass]="
          isAddCommentMode()
            ? 'bg-secondary !text-secondary-button-text'
            : 'bg-primary text-primary-button-text hover:bg-hover-primary'
        ">
        <i class="fas" [ngClass]="isAddCommentMode() ? 'fa-times' : 'fa-comment-medical'"></i>&nbsp;
        <span class="hidden @sm:inline">{{
          isAddCommentMode() ? 'Cancel' : 'Report Bug'
          }}</span>
      </button>
    </div>
  </header>

  @if (isLoading()) {
  <div class="flex items-center justify-center p-20 flex-1 w-full h-full">
    <i class="fas fa-circle-notch fa-spin text-5xl text-primary"></i>
  </div>
  } @else {
  <nz-splitter class="w-full h-full min-h-0 border-t border-primary-border">
    <nz-splitter-panel nzMin="500">
      <div class="bg-body-background overflow-auto @container relative h-full w-full min-h-0 min-w-0 custom-scrollbar"
        #scrollContainer [ngClass]="{ 'add-comment-mode-active': isAddCommentMode() }">
        <div class="min-w-full w-max min-h-full flex flex-col items-center p-4 @md:p-6">
          <div class="relative transition-all duration-300 flex flex-col text-left shrink-0 h-full flex-1"
            [style.width.px]="getCanvasWidth()">
            <div
              class="relative w-full flex-1 flex flex-col gap-4 min-h-[800px] bg-transparent overflow-visible shrink-0 transition-transform duration-700 [transform-style:preserve-3d]">
              @if (isAddCommentMode()) {
              <div
                class="bg-primary/10 border border-primary/20 text-primary px-4 py-3 rounded-xl text-sm text-center font-medium shadow-sm shrink-0 flex items-center justify-center gap-2">
                <i class="fas fa-mouse-pointer animate-pulse"></i> Click
                anywhere on the preview below to report a bug on the latest
                version.
              </div>
              }
              <div
                class="relative w-full h-[calc(100vh-140px)] flex flex-col bg-component-inner border border-secondary-border shadow-xl rounded-xl overflow-visible transition-all duration-300"
                #canvasWrapper>
                <div
                  class="h-10 bg-component-header border-b border-secondary-border flex items-center px-4 shrink-0 justify-between rounded-t-xl">
                  <div class="flex items-center gap-4">
                    <div class="flex gap-2 mr-2">
                      <span class="w-3 h-3 rounded-full bg-danger block opacity-80 shadow-sm"></span>
                      <span class="w-3 h-3 rounded-full bg-warning block opacity-80 shadow-sm"></span>
                      <span class="w-3 h-3 rounded-full bg-success block opacity-80 shadow-sm"></span>
                    </div>
                    <nz-tag nzColor="blue" nzBordered="false" class="m-0 text-xs font-semibold">Latest Version</nz-tag>
                  </div>
                  <div
                    class="bg-component-inner border border-secondary-border text-[10px] text-secondary-text rounded-md px-3 py-1 shadow-sm font-mono truncate max-w-sm ml-auto select-none opacity-80">
                    {{ definitionName() || 'Preview' }}
                  </div>
                </div>

                <div
                  class="relative w-full flex-1 flex flex-col transition-colors duration-200 pb-1 rounded-b-xl overflow-hidden"
                  #captureZone [class.show-comment-outlines]="showComments()">
                  <!-- Project the existing viewer instead of creating a new previewer -->
                  <ng-content select="[viewer]"></ng-content>
                </div>

                @if (showComments()) {
                @for (
                comment of visibleComments();
                track comment.id;
                let i = $index
                ) {
                @if (bubblePositions()[comment.id]) {
                <div [ngClass]="
                            getCanvasBubbleClass(
                              comment.id,
                              bubblePositions()[comment.id]?.isOrphaned,
                              comment.status
                            )
                          " [style.top.px]="bubblePositions()[comment.id].top"
                  [style.left.px]="bubblePositions()[comment.id].left"
                  [style.margin-top.px]="-32"
                  [style.font-size]="(visibleComments().length - i) > 99 ? 'x-small' : null" nz-tooltip
                  [nzTooltipTitle]="comment.content" nzTooltipPlacement="top" (click)="
                            selectComment(comment.id); $event.stopPropagation()
                          ">
                  {{ formatBubbleNumber(visibleComments().length - i) }}
                </div>
                }
                }

                @if (draftComment() && bubblePositions()['draft']) {
                <div
                  class="absolute w-[400px] bg-component-inner border border-primary-border shadow-2xl rounded-xl rounded-tl-sm p-3 z-[1050] flex flex-col gap-3 draft-popover"
                  [style.top.px]="bubblePositions()['draft'].top" [style.left.px]="bubblePositions()['draft'].left"
                  (click)="$event.stopPropagation()">
                  <div class="h-[250px] border border-secondary-border rounded overflow-hidden">
                    <rapider-markdown-editor [(value)]="draftComment()!.text" [placeholder]="'Describe the bug here...'"
                      class="block w-full h-full"></rapider-markdown-editor>
                  </div>
                  <div class="flex justify-end gap-2">
                    <button nz-button nzType="default" nzSize="small" (click)="cancelDraftComment()"
                      class="border-transparent text-secondary-text hover:bg-hover-default focus:outline-none font-semibold text-xs shadow-none bg-transparent">
                      Cancel
                    </button>
                    <button nz-button nzType="primary" nzSize="small" (click)="saveDraftComment()"
                      [disabled]="!draftComment()!.text.trim()"
                      class="bg-primary hover:bg-hover-primary text-primary-button-text border-none font-bold shadow-sm text-xs">
                      Report
                    </button>
                  </div>
                </div>
                }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </nz-splitter-panel>

    <nz-splitter-panel nzDefaultSize="400" nzMin="200" nzMax="500">
      <div
        class="bg-component-inner overflow-hidden flex flex-col shrink-0 h-full w-full border-l border-primary-border shadow-lg relative z-10">
        <!-- INJECT TABS HERE -->
        <ng-content select="[tabs]"></ng-content>

        <div class="flex flex-col flex-1 bg-body-background relative w-full overflow-hidden">
          <div
            class="p-2 border-b border-secondary-border bg-alt-background flex items-center justify-between shrink-0 h-[45px]">
            <div class="text-xs font-bold text-secondary-text ml-2">
              {{ visibleComments().length }} Bugs Reported
            </div>
            <div class="flex items-center gap-1">
              <button nz-button nzType="text" nzSize="small" nz-tooltip [nzTooltipTitle]="
                    showComments() ? 'Hide Bubbles' : 'Show Bubbles'
                  " (click)="toggleCommentsVisibility()"
                class="text-secondary-text hover:text-primary transition-colors focus:outline-none bg-component-inner border border-secondary-border shadow-sm w-7 h-7 flex items-center justify-center rounded">
                <i class="fas" [ngClass]="showComments() ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
          </div>

          <div class="flex-1 overflow-y-auto custom-scrollbar p-4 flex flex-col gap-4">
            @for (
            comment of paginatedComments();
            track comment.id;
            let i = $index
            ) {
            <div [id]="'comment-card-' + comment.id" (click)="selectComment(comment.id)"
              [ngClass]="getCommentCardClass(comment.id, comment.status)">
              <div class="flex items-center justify-between border-b pb-2" [ngClass]="
                      getCommentHeaderClass(comment.id, comment.status)
                    ">
                <div class="flex items-center gap-2">
                  <div [ngClass]="
                          getSidebarBubbleClass(
                            comment.id,
                            bubblePositions()[comment.id]?.isOrphaned,
                            comment.status
                          )
                        "
                    [style.font-size]="(visibleComments().length - (currentPage() - 1) * pageSize() - i) > 99 ? 'x-small' : null">
                    {{
                    formatBubbleNumber(
                    visibleComments().length -
                    (currentPage() - 1) * pageSize() -
                    i
                    )
                    }}
                  </div>
                </div>
                <div class="flex items-center gap-1">
                  @if (comment.status) {
                  <nz-tag class="!m-0 text-[10px] uppercase font-bold border-none bg-primary/10 text-primary">{{
                    comment.status }}</nz-tag>
                  }
                </div>
              </div>

              <div class="mt-2 text-sm overflow-hidden" [class.text-[#713f12]]="selectedCommentId() === comment.id">
                <rapider-markdown-preview [data]="comment.content || ''" [showHeader]="false" [showBorder]="false"
                  [isTransparent]="true"></rapider-markdown-preview>
              </div>

              <div class="flex justify-between items-center mt-2">
                <span class="text-[9px] transition-colors flex flex-col gap-0.5" [ngClass]="
                        selectedCommentId() === comment.id
                          ? 'text-[#a16207]'
                          : 'text-secondary-text'
                      ">
                  <span>{{ comment.createdBy || 'User' }} &bull;
                    {{ comment.createdDate | date: 'MMM d, h:mm a' }}</span>
                  <span class="font-semibold opacity-75 flex items-center gap-1 mt-1">
                    @if (getCommentViewMode(comment) === 'Desktop') {
                    <i class="fas fa-desktop text-[10px]"></i>
                    }
                    @if (getCommentViewMode(comment) === 'Tablet') {
                    <i class="fas fa-tablet-alt text-[10px]"></i>
                    }
                    @if (getCommentViewMode(comment) === 'Mobile') {
                    <i class="fas fa-mobile-alt text-[10px]"></i>
                    }
                    {{ getCommentViewMode(comment) }} View
                  </span>
                </span>

                @if (canDeleteComment(comment)) {
                <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Delete Bug Report" (click)="
                          deleteComment(comment.id); $event.stopPropagation()
                        "
                  class="text-danger hover:bg-danger/10 hover:text-danger rounded flex items-center justify-center w-7 h-7">
                  <i class="fas fa-trash-alt text-[11px]"></i>
                </button>
                }
              </div>
            </div>
            }

            @if (visibleComments().length === 0) {
            <div class="flex flex-col items-center justify-center p-6 text-center gap-2 opacity-60">
              <i class="far fa-comment-dots text-3xl text-secondary-text"></i>
              <span class="text-sm italic text-secondary-text">No bugs reported yet.</span>
            </div>
            }
          </div>

          @if (visibleComments().length > 0) {
          <div class="p-3 border-t border-secondary-border bg-alt-background shrink-0 flex justify-center">
            <nz-pagination [nzPageIndex]="currentPage()" [nzTotal]="visibleComments().length" [nzPageSize]="pageSize()"
              nzSize="small" (nzPageIndexChange)="currentPage.set($event)"></nz-pagination>
          </div>
          }
        </div>
      </div>
    </nz-splitter-panel>
  </nz-splitter>
  }
</div>